/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Secure_Access_LabelInputs */

const en_login_page_secure_access_label = /** @type {(inputs: Login_Page_Secure_Access_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure access`)
};

const de_login_page_secure_access_label = /** @type {(inputs: Login_Page_Secure_Access_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherer Zugriff`)
};

const pt_br2_login_page_secure_access_label = /** @type {(inputs: Login_Page_Secure_Access_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso seguro`)
};

const tr_login_page_secure_access_label = /** @type {(inputs: Login_Page_Secure_Access_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güvenli erişim`)
};

const zh_cn2_login_page_secure_access_label = /** @type {(inputs: Login_Page_Secure_Access_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全访问`)
};

const zh_hk2_login_page_secure_access_label = /** @type {(inputs: Login_Page_Secure_Access_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全存取`)
};

const ko_kr2_login_page_secure_access_label = /** @type {(inputs: Login_Page_Secure_Access_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보안 액세스`)
};

const ru_ru2_login_page_secure_access_label = /** @type {(inputs: Login_Page_Secure_Access_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасный доступ`)
};

const es_419_login_page_secure_access_label = /** @type {(inputs: Login_Page_Secure_Access_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso seguro`)
};

/**
* | output |
* | --- |
* | "Secure access" |
*
* @param {Login_Page_Secure_Access_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_secure_access_label = /** @type {((inputs?: Login_Page_Secure_Access_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Secure_Access_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_secure_access_label(inputs)
	if (locale === "de") return de_login_page_secure_access_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_secure_access_label(inputs)
	if (locale === "tr") return tr_login_page_secure_access_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_secure_access_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_secure_access_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_secure_access_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_secure_access_label(inputs)
	return es_419_login_page_secure_access_label(inputs)
});